import { defineComponent as _defineComponent } from 'vue'
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";
import BaseTable from "@/components-UI/table/BaseTable.vue";
import { ITableHeader, showServerError } from "@/utils";
import { IAffiliateInvoice, InvoicePartialPayment } from "@/api/types/payout";
import { computed, onMounted, ref } from "vue";
import { CellsType, prepareItems, RawConfig } from "@/utils/CellsFactory";
import ActionButton from "@/components-UI/buttons/ActionButton.vue";
import SvgTrash from "@/assets/icons/trash-white.svg";
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";
import SvgPlus from "@/assets/icons/plus.svg";
import AddPaymentForm from "@/components_v3/affiliate/invoices/AddPaymentForm.vue";
import BaseConfirmModal from "@/components-UI/modals/BaseConfirmModal.vue";
import { useAffiliateInvoiceStore } from "@/store_v3/AffiliateInvoiceStore";
import { storeToRefs } from "pinia";
import { deletePaymentMyLeadgidInvoice } from "@/api/payout";
import BaseQuestionMarkTooltip from "@/components-UI/BaseQuestionMarkTooltip.vue";
import store from "@/store";
import { USER_ROLES } from "@/mappings/user-roles";

interface Props {
    invoice: IAffiliateInvoice;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CrmPaymentsTable',
  props: {
    invoice: null
  },
  setup(__props: any) {

const props = __props as {
    invoice: IAffiliateInvoice;
}



const hint = 'В этом блоке отображаются платежи, проведённые через нашу систему: взаимозачёты, платежи созданные вручную через CRM или созданные в 1С.';

const isAdminRole = computed(() => {
    const adminRoles = [USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR];
    const user = store.getters['authModule/GET_USER'];
    return adminRoles.some(role => user.roles.includes(role));
});

const getHeaders = computed(() => {
    return isAdminRole.value ? headers : headers.toSpliced(headers.length - 1, 1);
});

const headers: ITableHeader[] = [
    { text: 'ID', value: 'id', width: '80px' },
    { text: 'Сумма', value: 'amount', align: 'right', width: '150px' },
    { text: 'Комментарий', value: 'description', width: 'auto' },
    { text: 'Досрочка', value: 'advance_payment_id', width: '150px', align: 'center' },
    { text: 'Счёт рекламодателя', value: 'advertiser_invoice_id', align: 'center', width: '150px' },
    { text: 'Автор', value: 'created_by', width: 'auto' },
    { text: 'Дата создания', value: 'created_at', width: '150px' },
    { text: '', value: 'actions', width: '50px', align: 'center' },
];

const config = ref<RawConfig<InvoicePartialPayment>>({
    [CellsType.Route]: {
        advertiser_invoice_id: {
            name: 'invoice',
            valueKey: 'advertiser_invoice_id',
            isChip: true,
            text: 'advertiser_invoice_id',
        },
        advance_payment_id: {
            name: 'payment',
            valueKey: 'advance_payment_id',
            isChip: true,
            text: 'advance_payment_id',
        },
    },
    [CellsType.Number]: {
        amount: {
            isMono: true,
        },
    },
    [CellsType.Date]: {
        created_at: {
            isLine: true,
        },
    },
    [CellsType.Uniq]: {
        actions: {},
    },
});

const { isNeedUpdateInvoice } = storeToRefs(useAffiliateInvoiceStore());

onMounted(() => {
    formatItems();
});

const formattedItems = ref([]);

const formatItems = () => {
    const columns = headers.map(i => i.value);
    formattedItems.value = prepareItems(props.invoice.partials, config.value, columns);
};

const addPaymentFormEl = ref(null);
const addPayment = () => {
    addPaymentFormEl.value?.openModal();
};

const confirmModal = ref(null);
const deletePayment = async (id: number) => {
    try {
        const message = `Вы уверены, что хотите удалить платёж ${id}?`;
        const isConfirm = await confirmModal.value?.openModal(message);
        if (isConfirm) {
            await deletePaymentMyLeadgidInvoice(props.invoice.id, id);
            isNeedUpdateInvoice.value = true;
        }
    } catch (err) {
        showServerError(err, 'Счет не удален');
    }
};

return { __sfc: true,props, hint, isAdminRole, getHeaders, headers, config, isNeedUpdateInvoice, formattedItems, formatItems, addPaymentFormEl, addPayment, confirmModal, deletePayment, BaseEditableCard, BaseTable, ActionButton, SvgTrash, BaseButtonV2, SvgPlus, AddPaymentForm, BaseConfirmModal, BaseQuestionMarkTooltip }
}

})